module.exports = __webpack_public_path__ + "img/zhuanye-xiaopiao.1be5a37a.svg";